export const ReportByCranesOrders = () => {
  const { start, end } = getCurrentFortnight();

  return {
    start: start.toISOString().split("T")[0],
    end: end.toISOString().split("T")[0],
    crane: "Todos",
    operator: "Todos",
    status: "Todas",
  };
};

export const getCurrentFortnight = () => {
  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth();
  const anio = fechaActual.getFullYear();

  let fechaInicio, fechaFin;

  if (dia <= 15) {
    // Primera quincena
    fechaInicio = new Date(anio, mes, 1);
    fechaFin = new Date(anio, mes, 15);
  } else {
    // Segunda quincena
    fechaInicio = new Date(anio, mes, 16);
    fechaFin = new Date(anio, mes + 1, 0);
  }

  return {
    start: fechaInicio,
    end: fechaFin,
  };
};

export const getCurrentFortnightNameByCranesOrders = (startDate, endDate) => {
  const spanishMonth = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  if (!startDate || !endDate) {
    const fechaActual = new Date();
    const dia = fechaActual.getDate();
    const mes = fechaActual.getMonth();
    const anio = fechaActual.getFullYear();

    let name = "";

    if (dia <= 15) {
      name = "Primera quincena";
    } else {
      name = "Segunda quincena";
    }

    return `${name} de ${spanishMonth[mes]} ${anio}`;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  const fechaActual = new Date();
  const diaActual = fechaActual.getDate();
  const mesActual = fechaActual.getMonth();
  const anioActual = fechaActual.getFullYear();

  let quincenaInicio, quincenaFin;

  if (diaActual <= 15) {
    quincenaInicio = new Date(anioActual, mesActual, 1);
    quincenaFin = new Date(anioActual, mesActual, 15);
  } else {
    quincenaInicio = new Date(anioActual, mesActual, 16);
    quincenaFin = new Date(anioActual, mesActual + 1, 0);
  }

  const normalizeDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const startNormalized = normalizeDate(start);
  const endNormalized = normalizeDate(end);
  const quincenaInicioNormalized = normalizeDate(quincenaInicio);
  const quincenaFinNormalized = normalizeDate(quincenaFin);

  const isCurrentFortnight =
    startNormalized.getTime() === quincenaInicioNormalized.getTime() &&
    endNormalized.getTime() === quincenaFinNormalized.getTime();

  if (isCurrentFortnight) {
    let name = "";
    if (diaActual <= 15) {
      name = "Primera quincena";
    } else {
      name = "Segunda quincena";
    }
    return `${name} de ${spanishMonth[mesActual]} ${anioActual}`;
  }

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = spanishMonth[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return `${formatDate(start)} - ${formatDate(end)}`;
};